module.exports = __webpack_public_path__ + "media/application/images/company/founders/Michael-Robinson-f5460e7d521cd1a38e522f0b2b169dad.jpg";